import React, { useContext } from 'react';
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
  DialogActions,
  Button,
  useId,
} from '@fluentui/react-components';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';
import type { ConversationDeleteDialogProps } from './types';

export const ConversationDeleteDialog = ({
  open, setOpen, onConfirm, conversationTitle,
}: ConversationDeleteDialogProps) => {
  const i18n = useContext(I18nContext) as I18nModel;

  const dialogId = useId('dialog-');

  return (
    <Dialog
      open={open}
      onOpenChange={(_e, data) => {
          setOpen(data.open);
        }}
    >
      <DialogSurface
        aria-labelledby={`${dialogId}-title`}
        aria-describedby={`${dialogId}-content`}
      >
        <DialogBody>
          <DialogTitle id={`${dialogId}-title`}>
            {i18n.getString(_TL_('Do you want to delete this chat?'))}
          </DialogTitle>
          <DialogContent id={`${dialogId}-content`}>
            {i18n.getString(_TL_('This will permanently delete the chat '))}
            <b>{conversationTitle}</b>
            {i18n.getString(_TL_(' and remove it from your Copilot chat history.'))}
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="primary" onClick={onConfirm} className="delete-dialog-confirm">{i18n.getString(_TL_('Yes'))}</Button>
            </DialogTrigger>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary" className="delete-dialog-cancel">{i18n.getString(_TL_('No'))}</Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
